import React from 'react';
import Carousel, { Modal, ModalGateway } from 'react-images';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import APIGet from '../../API/APIGet';
import APIPost from '../../API/APIPost';
import APIDelete from '../../API/APIDelete';
import APIHelper from '../../Helper/APIHelper';

import LoadingCenter from '../LoadingCenter';

export default class RestaurantCommentPhotos extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: false,
			images: [...props.images],
			selectedIndex: 0,
			lightboxIsOpen: false,
		};
	}

	componentDidMount = async () => {};

	getPhotos = async () => {
		const { restaurantId, commentId } = this.props;
		const request = await APIGet('restaurants/' + restaurantId + '/comments/' + commentId + '/photos');
		if (APIHelper.handleAPIResponse(this, request)) {
			const images = request.data;
			console.log('comments: ', images);
			this.setState({
				isLoading: false,
				images,
			});
		} else {
			toast.error('ไม่สามารถดึงข้อมูลได้');
		}
	};

	toggleLightbox = selectedIndex => {
		this.setState(state => ({
			lightboxIsOpen: !state.lightboxIsOpen,
			selectedIndex,
		}));
	};

	fileChangedHandler = event => {
		event.persist();
		let reader = new FileReader();
		let file = event.target.files[0];

		reader.onloadend = () => {
			var base64 = reader.result.substr(reader.result.indexOf(',') + 1);
			var newFile = {
				base64: base64,
				name: file.name,
				size: file.size,
			};

			this.uploadFile(newFile);
		};

		reader.onerror = error => {
			console.log('Error: ', error);
		};

		if (file) {
			reader.readAsDataURL(file);
		}
	};

	uploadFile = async file => {
		const { restaurantId, commentId } = this.props;
		this.setState({
			isLoading: true,
		});

		const request = await APIPost(`restaurants/${restaurantId}/comments/${commentId}/photos`, {
			uploadFile: file,
		});

		if (APIHelper.handleAPIResponse(this, request)) {
			this.setState({
				isLoading: false,
			});

			await this.getPhotos();
			toast.success('เพิ่มรูปเรียบร้อยแล้ว');
		} else {
			this.setState({
				isLoading: false,
			});

			toast.warn('เกิดปัญหาในการเพิ่มรูป');
		}
	};

	delete = async fileId => {
		const { restaurantId, commentId } = this.props;
		this.setState({
			isLoading: true,
		});

		const request = await APIDelete(`restaurants/${restaurantId}/comments/${commentId}/photos/${fileId}`);

		if (APIHelper.handleAPIResponse(this, request)) {
			this.setState({
				isLoading: false,
			});

			await this.getPhotos();
			toast.success('ลบรูปเรียบร้อยแล้ว');
		} else {
			this.setState({
				isLoading: false,
			});

			toast.warn('เกิดปัญหาในการลบรูป');
		}
	};

	render() {
		if (this.state.isLoading) {
			return <LoadingCenter />;
		}

		const { isLoading, images, lightboxIsOpen, selectedIndex } = this.state;
		const { isAllowEdit } = this.props;
		return (
			<>
				{images && images.length > 0 ? (
					<div className="row">
						{images.map((source, j) => (
							<div style={{ float: 'left', position: 'relative' }} key={source.src}>
								{isAllowEdit ? (
									<div style={{ position: 'absolute', top: -2, right: -2 }}>
										<a className="delete" onClick={() => this.delete(source.id)} />
									</div>
								) : null}
								<img
									alt={source.caption}
									src={source.src}
									css={{
										cursor: 'pointer',
										position: 'absolute',
										float: 'left',
									}}
									width="150"
									className="clickable"
									onClick={() => this.toggleLightbox(j)}
								/>
							</div>
						))}
					</div>
				) : (
					<div style={{ textAlign: 'center' }}>ยังไม่มีรูปภาพ</div>
				)}

				<div style={{ clear: 'both' }} />
				{isAllowEdit ? (
					<>
						<hr />
						<div className="row">
							<label className="file-label">
								<input className="file-input" type="file" name="resume" onChange={this.fileChangedHandler} />
								<span className="file-cta">
									<span className="file-icon">
										<FontAwesomeIcon icon="upload" />
									</span>
									<span className="file-label">Choose a photo...</span>
								</span>
							</label>
						</div>
					</>
				) : null}

				<ModalGateway>
					{lightboxIsOpen && !isLoading ? (
						<Modal onClose={this.toggleLightbox}>
							<Carousel currentIndex={selectedIndex} frameProps={{ autoSize: 'height' }} views={images} />
						</Modal>
					) : null}
				</ModalGateway>
			</>
		);
	}
}
